
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { financialDetail, financialBuy } from '../service/getdata'
import moment from 'moment';
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
info: {},
id: "",
money: "",
today: "",
endday: ""
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.id = this.$route.query.id
this.today = moment().format('YYYY-MM-DD');

this.getData()

},
methods:{
...mapMutations(['SETTOKEN', 'SETUSERNAME']),
getData(){
var that = this
this.$Loading()
financialDetail({token: this.token, id: this.id}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data
that.endday = moment().add(that.info.qixian, 'days').format('YYYY-MM-DD');
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
save(){
if(!this.money || this.money=='0'){
this.sendMsg(this.$t("请输入买入金额"))
return
}
var that = this
this.$Loading()
financialBuy({token: this.token, id: this.id, uid: window.localStorage.getItem("uid"), number: this.money}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.$router.go("-1")

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/trusteeship.vue